/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DividerModule } from 'primeng/divider';
@Component({
  selector: 'well-icon-text-divider',
  standalone: true,
  imports: [CommonModule, DividerModule],
  templateUrl: './icon-text-divider.component.html',
  styleUrl: './icon-text-divider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconTextDividerComponent {
  text = input<string | null>(null);
  textSize = input<string>('fs-5');
  faIconClass = input<string | null>(null);
  iconSize = input<string>('fa-xl');
}
